'use strict';
const Application = (()=>{
	let _instance = null,
		_locale = 'ru',
		_template,
		_config,
		_components,
		_default = {
			options: {
				template: {}
			}
		};
	class Application {
		constructor(config = {}) {
			if(_instance){
				return _instance;
			}
			{
				let {
					options: {
						template: template = _default.options.template
					}
				} = config;
				_config = {
					options: {template}
				}
			}
			_template = new Template(_config.options.template);
			_instance = this;
			return _instance;
		}
		static get Template () {
			return _template;
		}
		static get Locale () {
			return _locale;
		}
		static get Config () {
			return _config;
		}
		static get isTestMode () {
			return typeof getJasmineRequireObj() !== 'undefined';
		}
	}
	return {
		init(options){
			if(_instance){
				throw new Error('Could be initiated only once');
			}
			return new Application(options);
		},
		getInstance(){
			return new Application();
		}
	}
})();
class Debug {
	static print(text){
		document.getElementsByTagName('pre')[0].prepend(text+'\n');
	}
}